module.exports = __webpack_public_path__ + "img/branch_selected.edd6f9cb.svg";